import UserInfo from "./UserInfo";
import SideMenu from "./SideMenu";
import LoginInfo from "./LoginInfo";
import AccediInfo from "./AccediInfo";
import Close from "./CloseAccount";
import ChangePassword from "./ChangePassword";
import "./Settings.css";
import "../../components/forms/InfoItem.css";
import React, { Component } from "react";
import { connect } from "react-redux";

import { updateUser, logout, loginUser } from "../../reducers/user";
import { FaPen } from "react-icons/fa";

import "../../App.css";

class Settings extends Component {
  state = {
    inputsUser: inputsUserRaw,
    inputsLogin: inputsLoginRaw,
    showPopUp: false,
  };

  componentDidMount() {
    if (!this.props.user) {
      this.props.loginUser()
    }
  }

  componentDidUpdate(oldProps) {
    // console.log(this.props);
    if (
      oldProps.error !== this.props.error &&
      this.props.error === "no_user_in_local_storage"
    ) {
      window.location.href = "/";
    }
    if (oldProps.authToken !== this.props.authToken && !this.props.authToken) {
      window.location.href = "/";
    }
  }

  _handleChangeInput = (target, value) => {
    this.setState({ [target]: value });
  };

  _handleSubmit = async () => {
    const {
      firstname,
      lastname,
      companyName,
      password,
      oldPassword,
    } = this.state;

    await this.props.updateUser({
      firstname,
      lastname,
      companyName,
      password,
      oldPassword,
    });

    if (this.state.showPopUp && this.props.error === false) {
      this._togglePopUp();
      this.setState({
        firstname: null,
        lastname: null,
        companyName: null,
        password: null,
        oldPassword: null,
      });
    }
  };

  _togglePopUp = () => this.setState({ showPopUp: !this.state.showPopUp });

  _isDisabled = () => {
    const inputStatus = this.state.inputsUser.map(
      (input) => !!this.state[input.target] && this.state[input.target] !== ""
    );
    const inputAreValid =
      typeof inputStatus.find((input) => !!input) !== "undefined";

    return !inputAreValid;
  };

  _isDisabledPassword = () => {
    const inputPassword = [
      { target: "password" },
      { target: "oldPassword" },
      { target: "repeatPassword" },
    ];
    const inputStatus = inputPassword.map(
      (input) => !!this.state[input.target] && this.state[input.target] !== ""
    );
    const inputAreNotValid =
      typeof inputStatus.find((input) => !input) !== "undefined";
    const passwordMatch = this.state.password === this.state.repeatPassword;
    return inputAreNotValid || !passwordMatch;
  };

  render() {
    // console.log("error", this.props.error);
    return (
      <div className="setting-container">
        {this.state.showPopUp && (
          <ChangePassword
            togglePopUp={this._togglePopUp}
            handleSubmit={this._handleSubmit}
            handleChangeInput={this._handleChangeInput}
            disabled={this._isDisabledPassword()}
            error={this.props.error}
          />
        )}

        <div className="setting-main-container">
          <SideMenu userData={this.props.user} logout={this.props.logout} />
          <div className="setting-main" style={{ justifyContent: "flexStart", minHeight: 'calc(100vh - 88px)' }}>
            {
            // this.props.loading ? (
            //   <div className="loader-blue"></div>
            // ) : (
              this.props.user && (
                <>
                  <div className="setting-main-title">
                    <h1>Impostazioni account</h1>
                    <p>
                      Verifica e aggiorna i dettagli del tuo account, del tuo
                      profilo,ecc.
                    </p>
                  </div>
                  <UserInfo
                    submitButton={{
                      text: "MODIFICA",
                      disabled: this._isDisabled(),
                      loading: this.props.loading,
                    }}
                    inputs={this.state.inputsUser.map((input) => {
                      return {
                        ...input,
                        defaultValue: this.props.user[input.target],
                      };
                    })}
                    handleChangeInput={this._handleChangeInput}
                    handleSubmit={this._handleSubmit}
                  />
                  <LoginInfo
                    inputs={this.state.inputsLogin.map((input) => {
                      if (input.button) {
                        return {
                          ...input,
                          defaultValue: "1111111111",
                          button: {
                            text: input.button,
                            loading: this.props.loading,
                            handleClick: this._togglePopUp,
                          },
                        };
                      }
                      return {
                        ...input,
                        defaultValue: this.props.user[input.target],
                      };
                    })}
                    handleChangeInput={this._handleChangeInput}
                    inputDisabled={true}
                  />
                  {/* <AccediInfo /> */}
                  <Close />
                </>
              )
            // )
            }
          </div>
        </div>
      </div>
    );
  }
}

const inputsUserRaw = [
  {
    target: "firstname",
    placeholder: "Inserisci il tuo nome",
    type: "text",
    label: "Nome",
  },
  {
    target: "lastname",
    placeholder: "Inserisci il tuo cognome",
    type: "text",
    label: "Cognome",
  },

  {
    target: "companyName",
    placeholder: "Inserisci il tuo nome account",
    type: "text",
    label: "Nome Account",
  },
];

const inputsLoginRaw = [
  {
    target: "email",
    type: "email",
    label: "Email",
  },
  {
    target: "password",
    type: "password",
    label: "Password",
    button: <FaPen />,
  },
];

const mapStateToProps = (state) => ({
  user: state.user.data.user,
  authToken: state.user.data.authToken,
  loading: state.user.loading,
  error: state.user.error,
});

export default connect(mapStateToProps, { updateUser, logout, loginUser })(Settings);
